import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../shared/baseUrl";

function TafsirList() {
  const [tafsirData, setTafsirData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(baseUrl + "api/v1/tafsir")
      .then((res) => res.json())
      .then((data) => setTafsirData(Array.isArray(data) ? data : []))
      .catch(() => setTafsirData([]));
  }, []);

  return (
    <>
      <div className="reciters-grid">
        {tafsirData.map((tafsir) => (
          <button
            key={tafsir.id}
            className="reciter-card"
            onClick={() => navigate(`/tafsir/${tafsir.slug}`)}
          >
            <img
              src={
                tafsir.image
                  ? `${baseUrl}storage/${tafsir.image}`
                  : `${baseUrl}storage/images/tafsir.png`
              }
              alt={tafsir.title}
            />
            <div className="tafsir-info">
              <h3 className="title">{tafsir.title}</h3>
              <h3 className="author">{tafsir.author}</h3>
              <h3 className="language">Lang: {tafsir.language}</h3>
            </div>
          </button>
        ))}
      </div>
    </>
  );
}

export default TafsirList;
